'use client'

import { useMemo } from 'react'

import { FilterDropdownSize, Icon, IconComponent } from '@graftcode/design-system'

export type TimeRangeFilterTriggerProps = {
  id?: string
  triggerLabel: string
  disabled: boolean
  isOpen: boolean
  ariaTitle: string
}

export const TimeRangeFilterTrigger = function TimeRangeFilterTrigger({
  ref,
  id,
  triggerLabel,
  disabled,
  isOpen,
  ariaTitle,
  ...radixTriggerProps
}: TimeRangeFilterTriggerProps & { ref?: React.RefObject<HTMLDivElement | null> }) {
  const triggerClass = useMemo(() => {
    const classes = ['filter-dropdown', `filter-dropdown--${FilterDropdownSize.M}`]
    if (disabled) classes.push('filter-dropdown--disabled')
    return classes.join(' ')
  }, [disabled])

  return (
    <div
      ref={ref}
      id={id}
      {...radixTriggerProps}
      className={triggerClass}
      aria-label={ariaTitle}
      aria-haspopup="dialog"
      aria-disabled={disabled || undefined}
    >
      <span className="filter-dropdown__label">{triggerLabel}</span>
      <span className="filter-dropdown__chevron">
        <IconComponent icon={isOpen ? Icon.CaretUpFilled : Icon.CaretDownFilled} />
      </span>
    </div>
  )
}
